import { useContext } from 'react';

import LoadingSpinner from './LoadingSpinner';
import { SDKContext } from '../context/sdk';
import { useLoadDesign } from '../hooks/useLoadDesign';
import { useAttachCAD } from '../hooks/useAttachCAD';
import AutoJobButtonsPanel from './AutoJobButtonsPanel';
import PerformanceJobButtonsPanel from './PerformanceJobButtonsPanel';
import ToggleViewButtonsPanel from './ToggleViewButtonsPanel';
import { useGetToggleViews } from '../hooks/useGetToggleViews';
import { useHistory, useLocation } from 'react-router-dom';
import { ModifySolarPanelsSection } from './ModifySolarPanelsSection';
/**
 * This wraps the CAD view as well as containing various controls
 * and handling showing loading/error states
 * -- essentially a layout component.
 */
export default function SDKPanel() {
  const { design, error, sdk, setDesign } = useContext(SDKContext);
  const { loadedDesign = design } = useLoadDesign(sdk);
  const { attached, cadElementRef } = useAttachCAD(sdk, design);
  const history = useHistory();
  const location = useLocation();
  useGetToggleViews(design, attached);

  if (loadedDesign && loadedDesign !== design) {
    setDesign(loadedDesign);
    (window as any).design = loadedDesign;
  }

  if (error) {
    return (
      <div>
        <span>{error}</span>
      </div>
    );
  }

  if (!sdk) {
    return (
      <LoadingSpinner
        label={error ? `Error: ${error}` : 'Loading SDK'}
        button={
          <button
            style={{
              backgroundColor: 'orange',
              maxWidth: '24ch',
              margin: '12px auto',
            }}
            onClick={() => {
              const { search } = location;
              history.push({
                pathname: '../',
                search,
              });
            }}
          >
            Back to Login
          </button>
        }
      />
    );
  }

  if (!design && !loadedDesign) {
    return <LoadingSpinner label={error ? `Error: ${error}` : 'Loading Design'} />;
  }

  return (
    <div style={{ flexDirection: 'row' }}>
      <ToggleViewButtonsPanel />
      <div
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          borderColor: 'rgba(255, 255, 255, 0.5)',
          borderWidth: '3px',
          flexDirection: 'column',
          padding: 0,
        }}
      >
        <div
          style={{
            borderColor: 'green',
            borderWidth: '3px',
            height: '600px',
            padding: 0,
            margin: '0 auto',
            minWidth: '600px',
            minHeight: '600px',
            width: '600px',
          }}
        >
          {!attached && (
            <LoadingSpinner label={error ? `Error: ${error}` : 'Attaching CAD Canvas'} />
          )}
          {/**
           * This is the element for the CAD canvas, it cannot have child elements,
           * and must have its height and width explicitly defined:
           */}
          <div
            data-testid="cad-element"
            style={{
              height: '100%',
              width: '100%',
            }}
            ref={cadElementRef}
          ></div>
        </div>
        <PerformanceJobButtonsPanel />
      </div>
      <AutoJobButtonsPanel />
      <ModifySolarPanelsSection />
    </div>
  );
}
